<template>
  <v-tooltip 
    :top="tooltip.top"
    :bottom="tooltip.bottom"
    :left="tooltip.left"
    :right="tooltip.right"
    :disabled="tooltip.disabled"
  >
    <template v-slot:activator="{ on, attrs }">
      <v-btn
        v-show="show"
        plain
        :text="text"
        :tile="tile"
        :icon="icon!==undefined&&!tile"
        :ripple="ripple"
        :loading="loading"
        :color="controller.toggle ? pressColor : color"
        :width="size"
        :min-width="minWidth"
        :max-width="maxWidth"
        :min-height="minHeight"
        :max-height="maxHeight"
        :class="[contentClass, { 'disabled': disabled }]"
        class="m-btn-long"
        v-bind="attrs"
        v-on="on"
        @mousedown="start"
        @touchstart="start"
        @touchmove="moved"
        @mouseenter="over"
        @mouseleave="moved"
        @click.stop
      >
        <v-progress-linear
          v-if="progress&&tile&&controller.toggle"
          :value="controller.progress"
          absolute
          top
          height="36"
          background-opacity=".08"
          :color="pressColor"
          class="progress linear"
          :style="{ 'margin-top': '-6px', '--duration': duration+'ms' }"
        />
        <v-progress-circular
          v-else-if="progress&&controller.toggle"
          :value="controller.progress"
          :color="pressColor"
          :size="size"
          :background-color="backgroundColor"
          :rotate="rotate"
          background-opacity=".4"
          class="progress circular"
          :class="{ 'active': controller.toggle }"
          :style="{ '--duration': duration+'ms' }"
        />
        <slot>
          <v-icon
            v-if="icon!==undefined&&typeof icon == 'string'"
            style="z-index: 2"
            :small="small"
          >
            {{ icon }}
          </v-icon>
        </slot>
      </v-btn>
    </template>
    {{ tooltip.text }}
  </v-tooltip>
</template>

<style>

  .progress .v-progress-circular__overlay {
    transition-property: none !important;
  }
  .progress.circular {
    position: absolute;
  }
  .m-btn-long {
    overflow: hidden !important;
  }

  .m-btn-long.disabled {
    cursor: default;
  }

  .m-btn-long .v-btn__content {
    opacity: 1 !important;
  }
</style>

<script>
  export default {
    props: {
      show: {
        type: Boolean,
        default: true,
      },
      loading: {
        type: Boolean,
        default: false,
      },
      disabled: {
        type: Boolean,
        default: false,
      },
      icon: {
        type: String,
        default: undefined,
      },
      text: {
        type: Boolean,
        default: false,
      },
      tile: {
        type: Boolean,
        default: false,
      },
      duration: {
        type: [Number, String],
        default: 3000,
      },
      minWidth: {
        type: [Number, String],
        default: undefined
      },
      minHeight: {
        type: [Number, String],
        default: undefined
      },
      maxWidth: {
        type: [Number, String],
        default: undefined
      },
      maxHeight: {
        type: [Number, String],
        default: undefined
      },
      size: {
        type: [Number, String],
        default: 36,
      },
      rotate: {
        type: Number,
        default: -90,
      },
      color: {
        type: String,
        default: 'accent',
      },
      pressColor: {
        type: String,
        default: 'accent',
      },
      backgroundColor: {
        type: String,
        default: 'secondary',
      },
      tooltip: {
        type: Object,
        default: () => {
          return {
            top: false,
            bottom: false,
            left: false,
            right: false,
            disabled: true,
            text: '',
          }
        },
      },
      contentClass: {
        type: String,
        default: '',
      },
      small: {
        type: Boolean,
        default: false
      },
      progress: {
        type: Boolean,
        default: true
      },
      ripple: {
        type: Boolean,
        default: true
      },
    },

    data: () => ({
      toggle: false,
      controller: {
        toggle: false,
        timer: null,
        step: 0,
        progress: 0,
        timestamp: null,
        moved: false
      },
      options: {
        tooltip: {
          top: false,
          bottom: false,
          left: false,
          right: false,
          disabled: true,
          text: '',
        }
      }
    }),

    computed: {
      tooltipConfig () {
        return Object.assign(this.options.tooltip, this.tooltip);
      }
    },

    methods: {
      start () {
        if (this.disabled) return;
        this.controller.toggle = true;
        this.controller.step = this.duration / 100;
        this.controller.timestamp = Date.now();
        this.controller.timer = setTimeout(this.update, 100);
      },
      update () {
        if (this.disabled) return;
        if (this.controller.timer!=null&&this.controller.progress<100) {
          this.controller.progress += 100/this.controller.step;
          this.controller.timer = setTimeout(this.update, 100);
        }else if (this.controller.progress>=100) {
          this.$emit('press');
          this.cancel()
        }
      },
      over () {
        this.$emit('hover', true);
      },
      moved () {
        this.$emit('hover', false);
        if (this.disabled) return;
        if (!this.controller.moved) {
          this.cancel()
        }
      },
      cancel () {
        if (this.disabled) return;
        if (this.controller.toggle&&this.controller.progress<100) {
          this.$emit('cancel');
        }
        this.controller.toggle = false;
        this.controller.progress = 0;
        this.controller.timer = null;
        this.controller.timestamp = null;
        this.controller.moved = false;
      },
    },
    mounted () {
      document.addEventListener('touchend', this.cancel, false)
      document.addEventListener('mouseup', this.cancel)
    },
    beforeDestroy () {
      document.removeEventListener('touchend', this.cancel)
      document.removeEventListener('mouseup', this.cancel)
    },
  }
</script>